import { Box, Stack } from '@mui/material';
import type { PropsWithChildren } from 'react';

import {
  CopyToClipboardButton,
  copyToClipboardGroupKey,
} from '../buttons/copyToClipboardButton';

export const CellActionsWrapper = ({
  textToCopy,
  children,
}: PropsWithChildren<{ textToCopy: string }>) => {
  return (
    <Box className={copyToClipboardGroupKey} position='relative'>
      {children}
      <Box
        paddingLeft='16px'
        className='opacity-0 group-hover/copy:opacity-100 hover:opacity-100 transition-opacity'
        sx={{
          backgroundImage:
            'linear-gradient(90deg, transparent 0%, var(--cell-bg-color, var(--mui-palette-background-default)) 28%)',
        }}
        position='absolute'
        right='0'
        top='0'
      >
        <Stack direction='row' alignItems='center'>
          <CopyToClipboardButton
            textToCopy={textToCopy}
            size='small'
            showOnlyOnHover
          />
        </Stack>
      </Box>
    </Box>
  );
};
